import { Colours } from '@alienheadwars/football-card-manager-model';

export const neutralColours: Colours = {
  primaryBackgroundColour: 'rgba(0,0,0,0.5)',
  primaryColour: 'black',
  primaryTextColour: 'white',
  secondaryColour: 'white',
};

export const defaultColours: Colours = {
  primaryBackgroundColour: 'white',
  secondaryColour: 'grey',
  primaryTextColour: 'black',
  primaryColour: 'grey',
};
